import React from "react";
import {
  BsRecordFill,
  BsHeart,
  BsZoomIn,
  BsFillStarFill,
} from "react-icons/bs";
import { CiShoppingCart } from "react-icons/ci";
import Rating from "react-rating";

function ListChild({ img }) {
  return (
    <div className="flex mb-8 p-3 shadow-custom_two">
      {/* image container */}
      <div className="bg-red-100 w-64 h-44">
        <img alt="" src={img} />
      </div>
      {/* text container */}
      <div className="flex-1 ml-4">
        {/* title */}
        <h4 className="flex font-bold items-center text-xl font-fontOne mb-2">
          Accumsan Tincidunt
          <BsRecordFill className="ml-3" color="#8568FF" />
          <BsRecordFill color="#DE9034" />
          <BsRecordFill color="#EC42A2" />
        </h4>
        {/* price and rating */}
        <div className="mb-2 font-fontOne">
          $26.00
          <span className="line-through text-pink inline-block ml-2">
            $52.00
          </span>
          <Rating
            className="ml-3"
            initialRating="4"
            readonly
            fullSymbol={<BsFillStarFill className="mx-1" color="#FFC416" />}
            emptySymbol={<BsFillStarFill className="mx-1" color="gray" />}
          />
        </div>
        {/* description */}
        <p className="text-[#9295AA] max-h-14 overflow-clip mb-3 text-sm">
          Voluptate minim est tempor adipisicing dolor velit. Quis aliqua minim
          mollit amet sint sint enim enim elit non Lorem. Incididunt nulla
          consectetur enim sit ipsum sint sunt commodo pariatur esse enim dolore
          culpa.
        </p>
        {/* icons */}
        <div className=" flex items-start">
          <div className=" rounded-full bg-white shadow-lg  p-2 -translate-y-1 mr-4">
            <CiShoppingCart size={17} />
          </div>
          <div className=" rounded-full bg-white shadow-lg  p-2 mr-4">
            <BsHeart size={13} />
          </div>
          <div className=" rounded-full bg-white shadow-lg  p-2">
            <BsZoomIn size={13} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListChild;
